// Função para validar CPF
export const validateCPF = (cpf: string) => {
  // Remove caracteres não numéricos
  const sanitizedCpf = cpf.replace(/[^\d]/g, '')

  // Verifica se tem 11 dígitos
  if (sanitizedCpf.length !== 11) return false

  // Verifica se todos os dígitos são iguais
  if (/^(\d)\1+$/.test(sanitizedCpf)) return false

  // Cálculo do primeiro dígito verificador
  let sum = 0
  for (let i = 0; i < 9; i++) {
    sum += Number.parseInt(sanitizedCpf.charAt(i)) * (10 - i)
  }
  let remainder = sum % 11
  const digit1 = remainder < 2 ? 0 : 11 - remainder

  // Cálculo do segundo dígito verificador
  sum = 0
  for (let i = 0; i < 10; i++) {
    sum += Number.parseInt(sanitizedCpf.charAt(i)) * (11 - i)
  }
  remainder = sum % 11
  const digit2 = remainder < 2 ? 0 : 11 - remainder

  // Verifica se os dígitos verificadores estão corretos
  return (
    Number.parseInt(sanitizedCpf.charAt(9)) === digit1 &&
    Number.parseInt(sanitizedCpf.charAt(10)) === digit2
  )
}
